{
  "title": "الأمانات",
  "searchPlaceholder": "رقم الأمانة أو الرقم المرجعي أو اسم العميل أو هاتفه",
  "exportPdf": "تصدير PDF",
  "exportFile": "الأمانات",
  "columns": {
    "depositedAt": "تاريخ الإيداع",
    "recipient": "المستلم"
  },
  "filters": {
    "any": "الكل",
    "allStates": "الكل عدا الملغاة والمسودات",
    "dateType": "نوع التاريخ",
    "depositDate": "تاريخ الإيداع",
    "deliveryDate": "تاريخ التسليم"
  },
  "sortBy": "ترتيب حسب {{column}}",
  "rowActions": "إجراءات الأمانة {{number}}"
}
